<div class="layout horizontal space-between middle">
    <div class="layout horizontal left middle" style="width: 70%; color: #005a9e;">
        <div class="icon-wrapper layout horizontal center middle">
            <app-icon id="{{icon}}"></app-icon>
        </div>
        <span style="font-size: large;">{{title}}</span>
    </div>
    <app-button [label]="'BACK_TO_LIST' | translate" icon="arrow_back" (click)="goBack()"></app-button>
</div>